export const LD_QA_FLAG = 'qa';
export const LD_TASK_LIST_V2_TEMPLATE_EDITOR_FLAG =
  'task-list-v2-template-editor';
export const LD_ASYNC_TODOS_CREATE_FLAG = 'async-todo-list-create';
export const LD_SIGNUP_EMAIL_VALIDATION = 'signup-email-validation';
export const LD_PROJECT_TRASH_CAN_FLAG = 'project-trash-can';
export const LD_CASH_REFERRAL_FLAG = 'cash-referral-program';
export const LD_DOCUMENT_SIGNING = 'document-signing';
export const LD_COLLAB_REMOVE_PERMS_FLAG = 'collab-remove-perms';
export const LD_INTERCOM_HELP_CENTER_AND_MESSENGER_FLAG =
  'intercom-help-center-and-messenger';
export const LD_SIGN_UP_REQUIRE_HOW_HEARD_DETAIL_FLAG =
  'require-how-heard-detail-on-signup-form';
export const LD_SIGN_UP_REQUIRE_COMPANY_SIZE_FLAG =
  'display-company-size-field-on-signup-form';
export const LD_PROJECT_BLUEPRINTS_RENAME = 'project-blueprints-rename';
export const LD_PREMIUM_TRIAL_FOR_EXISTING =
  'growth-premium-trials-for-existing';
export const LD_PROJECT_MENU_GOOGLE_CALENDAR_OPTION_FLAG =
  'project-menu-google-calendar-option';
export const LD_TRUSTY_PAYMENTS_FEATURE_FLAG = 'trusty-payments';
export const LD_WORKFLOWS_SKIP_CHECKLIST_SECTIONS =
  'workflows-skip-checklist-sections';
export const LD_COMPARE_PLANS_PAGE = 'compare-plans-page';
export const LD_TRUSTY_SHARE_PHOTOS = 'trusty-share-photos';
export const LD_PROJECT_COLLAPSIBLE_SIDEBAR = 'project-collapsible-sidebar';
export const LD_ORGANIZATION_METRICS = 'organization-metrics';
export const LD_INTEGRATIONS_NEW_QBO_MODAL =
  'send-photos-to-quickbooks-records';
export const LD_WORKFLOWS_EXPIRING_SHARED_URLS =
  'workflows-expiring-shared-url';
export const LD_WORKFLOWS_REST_PROJECT_TASKS =
  'workflows-web-project-task-rest';
export const LD_EXPORT_PAGE_PDF_FLAG = 'export-page-pdf';
export const LD_WORKFLOWS_SWITCH_VIEW_REPORT_BUTTON =
  'workflows-switch-view-report-button';
export const LD_IMPROVED_INTEGRATIONS_PAGE =
  'improved-integration-directory-page';
export const LD_WORKFLOWS_ASSIGN_PROJECT_TASK =
  'workflows-assign-project-tasks';
export const LD_WORKFLOWS_PAGE_TEMPLATES = 'workflows-page-templates';
export const LD_DOCUMENTS_WIP_DOCUMENT_BUILDER = 'wip-document-builder';
export const LD_DOCUMENTS_DOCUMENT_BUILDER = 'document-builder';
export const LD_SECURE_UPLOADS_REQUESTS_WEB_FLAG =
  'secure-uploads-requests-web';
export const LD_MAP_PROJECT_CARDS = 'map-project-cards';
export const LD_REVIEWS_BETA_FLAG = 'reviews-beta';
export const LD_REVIEWS_FALSE_DOOR_FLAG = 'reviews-false-door';
export const LD_NEW_EMPTY_STATES = 'new-empty-states';
export const LD_REVIEWS_PLACE_ID_SELECT_FLAG = 'reviews-place-id-select';
export const LD_CONTRACTOR_PORTFOLIO = 'contractor-portfolio';
export const LD_ELITE_PLAN = 'elite-plan';
export const LD_YEAR_IN_REVIEW = 'year-in-review-2024';
export const LD_YEAR_IN_REVIEW_PUBLIC = 'year-in-review-2024-public';
export const LD_PROJECT_TEMPLATE_LABELS = 'project-template-labels';
export const LD_SHOWCASE_PROJECT_SUGGESTIONS = 'showcase-project-suggestions';
export const LD_SHOWCASE_PUBLIC_PROFILE = 'showcase-public-profile';
